
import React from 'react';
import { Card } from '@/components/ui/card';
import { useAuth } from '@/contexts/AuthContext';
import QuickSubmitForm from '@/components/QuickSubmitForm';
import AgentSubmissions from '@/components/AgentSubmissions';
import Navbar from '@/components/Navbar';
import HeroSection from '@/components/HeroSection';
import WorkflowSection from '@/components/WorkflowSection';
import BenefitsSection from '@/components/BenefitsSection';
import SOPExplanationSection from '@/components/SOPExplanationSection';
import ClientsSection from '@/components/ClientsSection';
import Footer from '@/components/Footer';
import SubmissionStats from '@/components/SubmissionStats';

const Index = () => {
  const {
    profile
  } = useAuth();
  const isRecruiter = profile?.role === 'recruiter';
  return <div className="min-h-screen bg-white pt-16">
      <Navbar />
      
      <HeroSection />
      
      <BenefitsSection />

      <div className="container mx-auto px-4 py-[32px]">
            <h2 className="text-3xl font-bold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-[#0EA5E9] to-[#6366F1]">Join the AI revolution!</h2>
            <Card className="max-w-2xl mx-auto bg-white border border-[#0EA5E9]/20 shadow-xl">
              <QuickSubmitForm />
            </Card>
          </div>
      
      <WorkflowSection />
      
      <SOPExplanationSection />
      
      {/* New Clients Section */}
      <ClientsSection />
      
      {/* Display statistics section */}
      <SubmissionStats />
      
      {/* Display different content based on user role */}
      {isRecruiter ? <div className="max-w-4xl mx-auto py-16 px-4">
          <h2 className="text-3xl font-bold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-[#0EA5E9] to-[#6366F1]">Agent Submissions</h2>
          <AgentSubmissions />
        </div> : <div className="py-16 bg-gradient-to-br from-white via-[#F0F9FF] to-[#E0F2FE]">
        </div>}
      
      <Footer />
    </div>;
};
export default Index;
